import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, getSortState } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';
import { convertDateTimeToPtBRWithYearWithoutSeconds } from 'app/shared/util/date-utils';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntities } from './virtual-fence-circle-alert.reducer';

export const VirtualFenceCircleAlert = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const virtualFenceCircleAlertList = useAppSelector(state => state.virtualFenceCircleAlert.entities);
  const loading = useAppSelector(state => state.virtualFenceCircleAlert.loading);
  const totalItems = useAppSelector(state => state.virtualFenceCircleAlert.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="virtual-fence-circle-alert-heading" data-cy="VirtualFenceCircleAlertHeading">
        <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.home.title">Virtual Fence Circle Alerts</Translate>
        <div className="d-flex justify-content-end">
          <Button className="mr-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.home.createLabel">Create new Virtual Fence Circle Alert</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {virtualFenceCircleAlertList && virtualFenceCircleAlertList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <DoNotShowInProduction>
                  <th className="hand" onClick={sort('id')}>
                    <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                  </th>
                </DoNotShowInProduction>
                <th className="hand" onClick={sort('type')}>
                  <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.type">Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.virtualFenceCircle">Virtual Fence Circle</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.vehiclePosition">Vehicle Position</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.description">Description</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {virtualFenceCircleAlertList.map((virtualFenceCircleAlert, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <DoNotShowInProduction>
                    <td>
                      <Button tag={Link} to={`${match.url}/${virtualFenceCircleAlert.id}`} color="link" size="sm">
                        {virtualFenceCircleAlert.id}
                      </Button>
                    </td>
                  </DoNotShowInProduction>
                  <td>{virtualFenceCircleAlert.type}</td>
                  <td>
                    {virtualFenceCircleAlert.virtualFenceCircle?.name || virtualFenceCircleAlert.virtualFencePolygon?.name || ''}
                  </td>
                  <td>
                    {virtualFenceCircleAlert.vehiclePosition
                      ? // <Link to={`vehicle-position/${virtualFenceCircleAlert.vehiclePosition.id}`}>
                        convertDateTimeToPtBRWithYearWithoutSeconds(virtualFenceCircleAlert.vehiclePosition.created)
                      : // </Link>
                        ''}
                  </td>
                  <td>{virtualFenceCircleAlert.virtualFenceCircle?.description ?? ''}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${virtualFenceCircleAlert.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <DoNotShowInProduction>
                        <Button
                          tag={Link}
                          to={`${match.url}/${virtualFenceCircleAlert.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                          color="primary"
                          size="sm"
                          data-cy="entityEditButton"
                        >
                          <FontAwesomeIcon icon="pencil-alt" />{' '}
                          <span className="d-none d-md-inline">
                            <Translate contentKey="entity.action.edit">Edit</Translate>
                          </span>
                        </Button>
                        <Button
                          tag={Link}
                          to={`${match.url}/${virtualFenceCircleAlert.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                          color="danger"
                          size="sm"
                          data-cy="entityDeleteButton"
                        >
                          <FontAwesomeIcon icon="trash" />{' '}
                          <span className="d-none d-md-inline">
                            <Translate contentKey="entity.action.delete">Delete</Translate>
                          </span>
                        </Button>
                      </DoNotShowInProduction>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.home.notFound">No Virtual Fence Circle Alerts found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={virtualFenceCircleAlertList && virtualFenceCircleAlertList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default VirtualFenceCircleAlert;
